"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = managePurchasesReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _installStatusModal = _interopRequireDefault(require("./installStatusModal"));

var _purchasedGood = _interopRequireDefault(require("./purchasedGood"));

var _refundModal = _interopRequireDefault(require("./refundModal"));

var _uninstallConfirmModal = _interopRequireDefault(require("./uninstallConfirmModal"));

var _uninstallModal = _interopRequireDefault(require("./uninstallModal"));

var _RowDeliveryState = _interopRequireDefault(require("../constants/RowDeliveryState"));

var initialState = (0, _immutable.fromJS)({
  checkGoodUsageStatus: _RequestStatusTypes.default.UNINITIALIZED,
  checkGoodUsageErrorIds: {},
  createAssetError: null,
  createAssetStatus: _RequestStatusTypes.default.UNINITIALIZED,
  createWebpageModalOpen: false,
  createNewAssetModal: {
    good: {},
    open: false
  },
  errorReinstallingGood: false,
  fetchRequestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  installStatusModal: {
    goodId: '',
    open: false
  },
  pollingGoodId: '',
  pollingGoodStatus: _RequestStatusTypes.default.UNINITIALIZED,
  paypalPurchaseDelay: false,
  purchaseActionsMenuGoodId: '',
  purchaseDetailsGoodId: '',
  purchasedGoodsDisplayOrder: [],
  purchasedGoods: {},
  redeliveringGood: false,
  refundModal: (0, _refundModal.default)(undefined, {}),
  uninstallConfirmModal: (0, _uninstallConfirmModal.default)(undefined, {}),
  uninstallModal: {
    modalType: '',
    goodName: '',
    goodSubtype: '',
    open: false,
    assetsWhereGoodInUse: [],
    packChildrenInUse: []
  }
});

function getPurchasedGoodsWithUpdatedPathsForNewlyPurchasedChildTemplates(newlyPurchasedGood, purchasedGoods, action) {
  return purchasedGoods.map(function (pg) {
    if (pg.get('parentId') === newlyPurchasedGood.get('goodId')) {
      return (0, _purchasedGood.default)(pg, action);
    }

    return pg;
  });
}

function managePurchasesReducer() {
  var managePurchases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.PURCHASE_DETAILS_CLOSED:
      return managePurchases.set('purchaseDetailsGoodId', '');

    case _ActionTypes.default.PURCHASE_DETAILS_OPENED:
      return managePurchases.set('purchaseDetailsGoodId', action.payload.purchasedGoodsKey);

    case _ActionTypes.default.PURCHASE_ACTIONS_MENU_CLOSED:
      return managePurchases.set('purchaseActionsMenuGoodId', '');

    case _ActionTypes.default.PURCHASE_ACTIONS_MENU_OPENED:
      return managePurchases.set('purchaseActionsMenuGoodId', action.payload.purchasedGoodsKey);

    case _ActionTypes.default.SHOW_UNINSTALL_CONFIRM_MODAL:
      return managePurchases.merge({
        uninstallConfirmModal: (0, _uninstallConfirmModal.default)(managePurchases.get('uninstallConfirmModal'), action),
        checkGoodUsageStatus: _RequestStatusTypes.default.UNINITIALIZED
      });

    case _ActionTypes.default.DISMISSED_UNINSTALL_CONFIRM_MODAL:
    case _ActionTypes.default.UNINSTALL_GOOD:
      return managePurchases.set('uninstallConfirmModal', (0, _uninstallConfirmModal.default)(managePurchases.get('uninstallConfirmModal'), action));

    case _ActionTypes.default.SHOW_UNINSTALL_MODAL:
      return managePurchases.merge({
        uninstallModal: (0, _uninstallModal.default)(managePurchases.get('uninstallModal'), action),
        checkGoodUsageStatus: _RequestStatusTypes.default.UNINITIALIZED
      });

    case _ActionTypes.default.DISMISSED_UNINSTALL_MODAL:
      return managePurchases.set('uninstallModal', (0, _uninstallModal.default)(managePurchases.get('uninstallModal'), action));

    case _ActionTypes.default.REFUND_MODAL_OPENED:
      return managePurchases.merge({
        refundModal: (0, _refundModal.default)(managePurchases.get('refundModal'), action),
        checkGoodUsageStatus: _RequestStatusTypes.default.UNINITIALIZED
      });

    case _ActionTypes.default.DISMISSED_REFUND_MODAL:
    case _ActionTypes.default.REFUND_SUBMITTED:
    case _ActionTypes.default.REFUND_SUBMITTED_SUCCESS:
      return managePurchases.set('refundModal', (0, _refundModal.default)(managePurchases.get('refundModal'), action));

    case _ActionTypes.default.REFUND_UPDATE_SUCCESS:
      {
        var goodIdToUpdate = managePurchases.get('purchaseDetailsGoodId') || action.payload.goodId;
        return managePurchases.mergeIn(['purchasedGoods', goodIdToUpdate, 'refund'], action.payload.refund);
      }

    case _ActionTypes.default.REFUND_CANCEL_SUCCESS:
      {
        var _goodIdToUpdate = managePurchases.get('purchaseDetailsGoodId') || action.payload;

        return managePurchases.mergeIn(['purchasedGoods', _goodIdToUpdate, 'deliveryStatus'], _RowDeliveryState.default.UNINSTALLED);
      }

    case _ActionTypes.default.PURCHASED_GOODS_RECEIVED:
      return managePurchases.merge({
        fetchRequestStatus: _RequestStatusTypes.default.SUCCEEDED,
        purchasedGoodsDisplayOrder: action.payload.purchasedGoodsDisplayOrder,
        purchasedGoods: action.payload.purchasedGoods,
        uninstallConfirmModal: (0, _uninstallConfirmModal.default)(managePurchases.get('uninstallConfirmModal'), action)
      });

    case _ActionTypes.default.TOGGLE_PURCHASED_PACK:
      return managePurchases.setIn(['purchasedGoods', action.payload.goodId], (0, _purchasedGood.default)(managePurchases.getIn(['purchasedGoods', action.payload.goodId]), action));

    case _ActionTypes.default.GOOD_USAGE_INFO_RECEIVED:
    case _ActionTypes.default.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return managePurchases.setIn(['purchasedGoods', action.payload.purchasedGoodsKey], (0, _purchasedGood.default)(managePurchases.getIn(['purchasedGoods', action.payload.purchasedGoodsKey]), action));

    case _ActionTypes.default.CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED:
      {
        var errorId = action.payload.errorId;
        var checkGoodUsageErrorIds = managePurchases.get('checkGoodUsageErrorIds');
        var updatedCheckGoodUsageErrorIds = errorId ? checkGoodUsageErrorIds.delete(errorId) : checkGoodUsageErrorIds.clear();
        return managePurchases.merge({
          checkGoodUsageStatus: updatedCheckGoodUsageErrorIds.size ? _RequestStatusTypes.default.FAILED : _RequestStatusTypes.default.UNINITIALIZED,
          checkGoodUsageErrorIds: updatedCheckGoodUsageErrorIds
        });
      }

    case _ActionTypes.default.CHECK_GOOD_USAGE:
      if (action.error) {
        var _errorId = action.payload.errorId;
        return managePurchases.mergeDeep({
          checkGoodUsageStatus: _RequestStatusTypes.default.FAILED,
          checkGoodUsageErrorIds: (0, _defineProperty2.default)({}, _errorId, true)
        });
      }

      return managePurchases.set('checkGoodUsageStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.CREATE_ASSET:
      return managePurchases.merge({
        createAssetError: action.error ? action.payload.error : null,
        createAssetStatus: action.error ? _RequestStatusTypes.default.FAILED : _RequestStatusTypes.default.PENDING
      });

    case _ActionTypes.default.PURCHASED_GOODS_REQUESTED:
      if (action.error) {
        return managePurchases.set('fetchRequestStatus', _RequestStatusTypes.default.FAILED);
      }

      return managePurchases.set('fetchRequestStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.PURCHASED_WITH_STRIPE:
      if (!action.error) {
        return managePurchases.set('pollingGoodId', action.payload);
      }

      return managePurchases;

    case _ActionTypes.default.PAYPAL_PURCHASE_COMPLETED:
      return managePurchases.merge({
        pollingGoodId: action.payload.goodId
      });

    case _ActionTypes.default.REDELIVERING_GOOD:
      return managePurchases.merge({
        pollingGoodId: action.payload.goodId,
        redeliveringGood: true
      });

    case _ActionTypes.default.POLLING_GOOD_INFO_RECEIVED:
      {
        var managePurchasesWithUpdatedPollingGoodStatus = managePurchases.merge({
          pollingGoodId: action.payload.goodId,
          pollingGoodStatus: action.payload.goodStatus
        });

        if (action.payload.goodStatus === _RequestStatusTypes.default.SUCCEEDED) {
          var newlyPurchasedGood = managePurchasesWithUpdatedPollingGoodStatus.getIn(['purchasedGoods', action.payload.goodId.toString()]);

          if (!newlyPurchasedGood) {
            return managePurchases.set('paypalPurchaseDelay', true);
          }

          if (newlyPurchasedGood.get('totalChildren')) {
            return managePurchasesWithUpdatedPollingGoodStatus.set('redeliveringGood', false).set('purchasedGoods', getPurchasedGoodsWithUpdatedPathsForNewlyPurchasedChildTemplates(newlyPurchasedGood, managePurchasesWithUpdatedPollingGoodStatus.get('purchasedGoods'), action));
          }

          return managePurchasesWithUpdatedPollingGoodStatus.set('redeliveringGood', false).setIn(['purchasedGoods', action.payload.goodId.toString()], (0, _purchasedGood.default)(newlyPurchasedGood, action));
        }

        return managePurchasesWithUpdatedPollingGoodStatus;
      }

    case _ActionTypes.default.OPEN_SLOW_DELIVERY_MODAL:
    case _ActionTypes.default.DISMISSED_INSTALL_STATUS_MODAL:
      return managePurchases.set('installStatusModal', (0, _installStatusModal.default)(managePurchases.get('installStatusModal'), action));

    case _ActionTypes.default.ERROR_REINSTALLING_GOOD:
      return managePurchases.set('errorReinstallingGood', true);

    case _ActionTypes.default.PAYPAL_DELAY_ERROR_ALERT_DISMISSED:
      return managePurchases.set('paypalPurchaseDelay', false);

    case _ActionTypes.default.DISMISSED_REINSTALLATION_ERROR_ALERT:
      return managePurchases.set('errorReinstallingGood', false);

    case _ActionTypes.default.CREATE_WEBPAGE_MODAL_OPENED:
      return managePurchases.set('createWebpageModalOpen', true);

    case _ActionTypes.default.CREATE_WEBPAGE_MODAL_DISMISSED:
      return managePurchases.set('createWebpageModalOpen', false);

    case _ActionTypes.default.CREATE_NEW_ASSET_MODAL_OPENED:
      return managePurchases.set('createNewAssetModal', {
        open: true,
        good: action.payload.good
      });

    case _ActionTypes.default.CREATE_NEW_ASSET_MODAL_DISMISSED:
      return managePurchases.merge({
        createAssetError: null,
        createAssetStatus: _RequestStatusTypes.default.UNINITIALIZED,
        createNewAssetModal: {
          open: false,
          good: {}
        }
      });

    default:
      return managePurchases;
  }
}

module.exports = exports.default;